import {Reducer} from 'redux';
import {HTML_MODAL, HtmlModalActionTypes} from '../actions/types/html.types';

export interface HtmlReducerState {
    showEditorModal: boolean;
}

export const preloadedState: HtmlReducerState = {
    showEditorModal: false,
};

export const htmlReducer: Reducer<HtmlReducerState> = (
    state: HtmlReducerState = preloadedState,
    action: HtmlModalActionTypes
): HtmlReducerState => {
    switch (action.type) {
        case HTML_MODAL:
            return {...state, showEditorModal: !state.showEditorModal};
        default:
            return {...state};
    }
};
